import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vModelText as _vModelText, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "u-text-align-special" }
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--no-space o-grid__cell--12 o-grid__cell--6-1024 o-grid__cell--offset-4-1024" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["max", "required", "aria-required", "data-fehlermeldung"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_adresse = _resolveComponent("adresse")!
  const _component_infotext = _resolveComponent("infotext")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_gebaeude_typ = _resolveComponent("gebaeude-typ")!
  const _component_BauartklasseErmittlung = _resolveComponent("BauartklasseErmittlung")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      active: 0,
      items: _ctx.navItems,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      _createVNode(_component_ueberschrift, null, {
        default: _withCtx(() => _cache[20] || (_cache[20] = [
          _createTextVNode("Angaben zur Versicherung")
        ])),
        _: 1,
        __: [20]
      }),
      _createVNode(_component_adresse, {
        fehler: _ctx.fehler,
        placeholder: true,
        plz: _ctx.piniaStore.state.risikoAnschrift.plz,
        "onUpdate:plz": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.plz) = $event)),
        ort: _ctx.piniaStore.state.risikoAnschrift.ort,
        "onUpdate:ort": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.ort) = $event)),
        strasse: _ctx.piniaStore.state.risikoAnschrift.strasse,
        "onUpdate:strasse": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.strasse) = $event)),
        hausnummer: _ctx.piniaStore.state.risikoAnschrift.hausnummer,
        "onUpdate:hausnummer": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.hausnummer) = $event)),
        "zu-pruefen": _ctx.piniaStore.state.risikoAnschrift.zuPruefen,
        "onUpdate:zuPruefen": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.zuPruefen) = $event)),
        feldNamen: {
        plz: 'risikoPostalCode',
        ort: 'risikoCity',
        strasse: 'risikoStreet',
        hausnummer: 'risikoStreetNumber',
      },
        ref: "addresseRef",
        "session-marker": "risikoAnschrift"
      }, {
        plzOrtLabel: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, [
            _cache[21] || (_cache[21] = _createElementVNode("strong", null, "Anschrift", -1)),
            _cache[22] || (_cache[22] = _createTextVNode(" der Immobilie ")),
            _createElementVNode("span", {
              class: "c-notice-icon",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.wechsleSichtbarkeit('infoAnschrift')))
            }, [
              _createVNode(_component_icon_sprite, { "icon-name": "icon-info-i" })
            ])
          ])
        ]),
        strasseHausnummerLabel: _withCtx(() => _cache[23] || (_cache[23] = [
          _createElementVNode("span", { class: "mobil-hidden" }, " ", -1)
        ])),
        _: 1
      }, 8, ["fehler", "plz", "ort", "strasse", "hausnummer", "zu-pruefen"]),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_infotext, {
              name: "infoAnschrift",
              "css-klassen": "o-grid__cell--no-space",
              text: "Diese Angaben werden für die Beitragsberechnung benötigt."
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, null, {
            default: _withCtx(() => _cache[24] || (_cache[24] = [
              _createElementVNode("strong", null, "Örtliche Lage", -1),
              _createTextVNode(" der Immobilie")
            ])),
            _: 1,
            __: [24]
          }),
          _createVNode(_component_zelle, { class: "mkRadio" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.oertlicheLage) = $event)),
                type: "radio",
                id: "innerhalbOrtschaft",
                name: "oertlicheLage",
                value: 1,
                required: "",
                "aria-required": "true",
                "aria-label": "Immobilie befindet sich innerhalb einer geschlossenen Ortschaft",
                "data-fehlermeldung": "Bitte treffen Sie eine Auswahl",
                "data-cy": "OertlicheLageInnerhalb"
              }, null, 512), [
                [
                  _vModelRadio,
                  _ctx.piniaStore.state.ferienhaus.oertlicheLage,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[25] || (_cache[25] = _createElementVNode("label", {
                class: "radiolabel",
                for: "innerhalbOrtschaft"
              }, "Innerhalb geschlossener Ortschaft", -1)),
              _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.oertlicheLage) = $event)),
                type: "radio",
                id: "außerhalbOrtschaft",
                name: "oertlicheLage",
                value: 2,
                "aria-label": "Immobilie befindet sich ausserhalb einer geschlossenen Ortschaft",
                "data-cy": "OertlicheLageAußerhalb"
              }, null, 512), [
                [
                  _vModelRadio,
                  _ctx.piniaStore.state.ferienhaus.oertlicheLage,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[27] || (_cache[27] = _createElementVNode("label", {
                class: "radiolabel",
                for: "außerhalbOrtschaft"
              }, "Außerhalb geschlossener Ortschaft", -1)),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.oertlicheLage,
                "reduzierter-abstand": true
              }, null, 8, ["fehler-text"])
            ]),
            _: 1,
            __: [25,26,27]
          })
        ]),
        _: 1
      }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, {
            "zeige-info": true,
            "info-box-id": "hausverwaltung"
          }, {
            default: _withCtx(() => _cache[28] || (_cache[28] = [
              _createTextVNode("Gebäude durch "),
              _createElementVNode("strong", null, "Hausverwaltung", -1),
              _createTextVNode(" kontrolliert? ")
            ])),
            _: 1,
            __: [28]
          }),
          _createVNode(_component_zelle, { class: "mkRadio" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.kontrolleHausverwaltung) = $event)),
                type: "radio",
                id: "keineHausverwaltung",
                name: "hausverwaltung",
                value: false,
                required: "",
                "aria-required": "true",
                "aria-label": "Nein, das Gebäude wird nicht durch eine Hausverwaltung kontrolliert",
                "data-fehlermeldung": "Bitte treffen Sie eine Auswahl.",
                "data-cy": "hausverwaltungRadioNo"
              }, null, 512), [
                [_vModelRadio, _ctx.piniaStore.state.ferienhaus.kontrolleHausverwaltung]
              ]),
              _cache[29] || (_cache[29] = _createElementVNode("label", {
                for: "keineHausverwaltung",
                class: "radiolabel"
              }, "Nein", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.kontrolleHausverwaltung) = $event)),
                type: "radio",
                id: "hausverwaltung",
                name: "hausverwaltung",
                value: true,
                "aria-label": "Ja, das Gebäude wird durch eine Hausverwaltung kontrolliert",
                "data-cy": "hausverwaltungRadioYes"
              }, null, 512), [
                [_vModelRadio, _ctx.piniaStore.state.ferienhaus.kontrolleHausverwaltung]
              ]),
              _cache[30] || (_cache[30] = _createElementVNode("label", {
                for: "hausverwaltung",
                class: "radiolabel"
              }, "Ja", -1)),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.hausverwaltung,
                "reduzierter-abstand": true
              }, null, 8, ["fehler-text"]),
              _createVNode(_component_infotext, {
                name: "hausverwaltung",
                "css-klassen": "o-grid__cell--no-space",
                text: "Wird die regelmäßige Kontrolle des Objektes durch eine Fremdfirma durchgeführt?"
              })
            ]),
            _: 1,
            __: [29,30]
          })
        ]),
        _: 1
      }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, null, {
            default: _withCtx(() => _cache[31] || (_cache[31] = [
              _createElementVNode("strong", null, "Art der Immobilie", -1)
            ])),
            _: 1,
            __: [31]
          }),
          _createVNode(_component_zelle, { class: "mkRadio" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.immobilieArt) = $event)),
                type: "radio",
                id: "ferienhaus",
                name: "immobilieArt",
                value: "1",
                required: "",
                "aria-required": "true",
                "aria-label": "Ferienhaus",
                "data-fehlermeldung": "Bitte treffen Sie eine Auswahl",
                "data-cy": "ImmobilieArtFerienhaus"
              }, null, 512), [
                [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.immobilieArt]
              ]),
              _cache[32] || (_cache[32] = _createElementVNode("label", {
                for: "ferienhaus",
                class: "radiolabel"
              }, "Ferienhaus", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.immobilieArt) = $event)),
                type: "radio",
                id: "ferienwohnung",
                name: "immobilieArt",
                value: "2",
                "aria-label": "Ferienwohnung",
                "data-cy": "ImmobilieArtFerienwohnung"
              }, null, 512), [
                [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.immobilieArt]
              ]),
              _cache[33] || (_cache[33] = _createElementVNode("label", {
                for: "ferienwohnung",
                class: "radiolabel"
              }, "Ferienwohnung", -1)),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.immobilieArt,
                "reduzierter-abstand": true
              }, null, 8, ["fehler-text"])
            ]),
            _: 1,
            __: [32,33]
          })
        ]),
        _: 1
      }),
      (_ctx.istFerienhaus(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_gebaeude_typ, {
            key: 0,
            fehler: _ctx.fehler
          }, null, 8, ["fehler"]))
        : _createCommentVNode("", true),
      (_ctx.istFerienhaus(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[34] || (_cache[34] = [
                  _createElementVNode("strong", null, "Was möchten Sie versichern?", -1)
                ])),
                _: 1,
                __: [34]
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("select", {
                    id: "versicherungsumfang",
                    name: "versicherungsumfang",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.versicherungsumfang) = $event)),
                    class: "c-form-control-select",
                    "data-fehlermeldung": "Bitte treffen Sie eine Auswahl.",
                    "data-cy": "versicherungsumfang",
                    "aria-label": "Was möchten Sie versichern?"
                  }, [
                    _cache[35] || (_cache[35] = _createElementVNode("option", { value: "0001" }, "Wohngebäude- und Hausratversicherung", -1)),
                    _cache[36] || (_cache[36] = _createElementVNode("option", { value: "0002" }, "Wohngebäudeversicherung", -1)),
                    _createElementVNode("option", {
                      disabled: _ctx.istMehrfamilienhaus(_ctx.piniaStore.state),
                      value: "0003"
                    }, "Hausratversicherung", 8, _hoisted_3)
                  ], 512), [
                    [_vModelSelect, _ctx.piniaStore.state.ferienhaus.versicherungsumfang]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.versicherungsumfang,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.piniaStore.state.isMakler === false && _ctx.istNurVHV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_zelle, {
                breite: 6,
                offset: 4
              }, {
                default: _withCtx(() => _cache[37] || (_cache[37] = [
                  _createElementVNode("div", { class: "u-copy-s gev19-infotext--grey" }, " Unsere Hausratversicherung gilt für Häuser und Wohnungen, bei denen es sich um Massiv- oder Fertighäuser mit hartem Dach handelt. ", -1)
                ])),
                _: 1,
                __: [37]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.istFerienhaus(_ctx.piniaStore.state) && _ctx.enthaeltVGV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_ueberschrift, { key: 3 }, {
            default: _withCtx(() => _cache[38] || (_cache[38] = [
              _createTextVNode("Angaben zur Immobilie")
            ])),
            _: 1,
            __: [38]
          }))
        : _createCommentVNode("", true),
      (_ctx.istFerienhaus(_ctx.piniaStore.state) && _ctx.enthaeltVGV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 4 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[39] || (_cache[39] = [
                  _createElementVNode("strong", null, "Baujahr", -1),
                  _createTextVNode(" des Gebäudes")
                ])),
                _: 1,
                __: [39]
              }),
              _createVNode(_component_zelle, { breite: 3 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    id: "baujahr",
                    name: "baujahr",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.baujahr) = $event)),
                    onKeydown: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    onKeyup: _cache[16] || (_cache[16] = ($event: any) => (_ctx.feldBlurFocus($event, 900))),
                    class: "c-form-control__input",
                    "data-cy": "baujahr",
                    onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.checkBaujahr && _ctx.checkBaujahr(...args))),
                    min: "1800",
                    max: _ctx.naechstesJahr,
                    required: _ctx.istFerienhaus(_ctx.piniaStore.state) && _ctx.enthaeltVGV(_ctx.piniaStore.state),
                    "aria-required": _ctx.istFerienhaus(_ctx.piniaStore.state) && _ctx.enthaeltVGV(_ctx.piniaStore.state),
                    "data-fehlermeldung": _ctx.baujahrFehlerText,
                    placeholder: "JJJJ",
                    "aria-label": "Baujahr des Gebäudes"
                  }, null, 40, _hoisted_4), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.gebaeudedaten.baujahr,
                      void 0,
                      {
                        lazy: true,
                        trim: true,
                        number: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.baujahr
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      ((_ctx.istFerienhaus(_ctx.piniaStore.state) && _ctx.enthaeltVGV(_ctx.piniaStore.state)) || _ctx.piniaStore.state.isMakler)
        ? (_openBlock(), _createBlock(_component_BauartklasseErmittlung, {
            key: 5,
            fehler: _ctx.fehler
          }, null, 8, ["fehler"]))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            breite: 5,
            offset: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "c-button c-button--full-width u-mar-t-2 u-mar-b-2 mobil-mehrAbstand",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                "data-cy": "submitZuImmobiliendetails"
              }, " Weiter zu Immobilien-Details ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.istSichtbar('modalMehrfamilienhausVHV'))
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onCloseModal: _cache[19] || (_cache[19] = ($event: any) => (_ctx.wechsleSichtbarkeit('modalMehrfamilienhausVHV'))),
          titel: _ctx.modalMehrfamilienhausVHV.titel,
          "hat-schliessen-button": _ctx.modalMehrfamilienhausVHV.hatSchliessenButton,
          "schliessen-button-text": _ctx.modalMehrfamilienhausVHV.schliessenButtonText
        }, {
          inhalt: _withCtx(() => [
            _createElementVNode("span", {
              innerHTML: _ctx.modalMehrfamilienhausVHV.text
            }, null, 8, _hoisted_5)
          ]),
          _: 1
        }, 8, ["titel", "hat-schliessen-button", "schliessen-button-text"]))
      : _createCommentVNode("", true)
  ], 64))
}